<template>
  <div class="text-center">
    <v-menu v-model="menu" :close-on-content-click="false" bottom offset-y>
      <template v-slot:activator="{ props }">
        <v-chip :color="filteredCustomerName ? 'primary' : 'primary'" v-bind="props" label>
          {{ $t("common.action.customer") }}
          <span v-if="filteredCustomerName">&nbsp;|&nbsp;</span>
          <span class="font-weight-bold"> {{ filteredCustomerName }}</span>
          <v-btn
            v-if="filteredCustomerName"
            variant="text"
            size="x-small"
            icon="mdi-close"
            @click.stop="reset()"
          />
        </v-chip>
      </template>

      <v-card min-width="350" class="mt-2">
        <v-list>
          <v-list-item :title="$t('page.payment.filter.filterByCustomer')">
            <template v-slot:append>
              <v-btn variant="text" icon="mdi-close" @click="menu = false" />
            </template>
          </v-list-item>
        </v-list>

        <v-divider />

        <v-list class="mt-1 mx-6">
          <customer-search-and-select @customer-selected="handleCustomerSelected" />
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { usePaymentStore } from "@/payments/stores/payments";
import CustomerSearchAndSelect from "@/shared/components/Common/CustomerSearchAndSelect.vue";
import type { Customer } from "@/customers/types/customer";

const menu = ref(false);
const filteredCustomerName = ref<string>("");

const { setFilterPaymentCondition } = usePaymentStore();

const reset = async () => {
  filteredCustomerName.value = "";
  const filterPaymentCondition = usePaymentStore().filterPaymentCondition;
  delete filterPaymentCondition.customer;
  await usePaymentStore().getFilteredPayments();
  setFilterPaymentCondition(filterPaymentCondition);
};

const handleCustomerSelected = (customer: Customer) => {
  const oldCondition = usePaymentStore().filterPaymentCondition;
  const newCondition = {
    ...oldCondition,
    customer: String(customer.id),
  };
  setFilterPaymentCondition(newCondition);
  filteredCustomerName.value = customer.name ?? "";
};
</script>
